import React from 'react';

const DocFr = () => {
    return (
        <>
            <p>L'autorisation se fait selon le protocole Oauth2 avec authorization_code.</p>

            <p>Une fois la clé créée, vous aurrez accès à :</p>
            <ul>
                <li>une clé d'application</li>
                <li>une clé secrète</li>
            </ul>
            <p>Vous pourrez ensuite "Autoriser" l'application, ce qui vous donnera le code d'autorisation.</p>

            <h2>Obtention et utilisation du token</h2>

            <p>Avec tous ces éléments, vous pourrez obtenir le token de connexion. Voici la marche à suivre en utilisant curl :</p>
            <pre>
curl -X POST -H "Content-Type: application/x-www-form-urlencoded" -d "grant_type=authorization_code&code=[CODE]&redirect_uri=https://dashboard.singlespot.com/oauth/applications&client_id=[APPLICATION_KEY]&client_secret=[SECRET]" https://dashboard.singlespot.com/oauth/token
            </pre>
            <p>Il faut remplacer :</p>
            <ul>
                <li><em>[CODE]</em> : code d'autorisation</li>
                <li><em>[APPLICATION_KEY]</em> : clé d'application</li>
                <li><em>[SECRET]</em> : clé secrète</li>
            </ul>
            <p>La reponse est de la forme suivante :</p>
            <pre>
{"{"}
    "access_token":"[TOKEN]",
    "token_type":"Bearer",
    "expires_in":7200,
    "refresh_token":"[REFRESH_TOKEN]",
    "scope":"publisher_api",
    "created_at":1564581408
{"}"}
            </pre>

            <ul>
                <li><em>access_token</em>: le token à utiliser pour l'accès</li>
                <li><em>expires_in</em>: le temps avant expiration du token</li>
                <li><em>refresh_token</em>: token à utiliser pour rafraichir le token avant expiration</li>
            </ul>

            <p>Le token peut maintenant être utilisé dans le header :</p>

            <pre>
curl https://api.singlespot.com/publisher_api/v1/devices -H "Authorization: Bearer [TOKEN]"
            </pre>

            <p>Pour plus d'informations, vous pouvez consulter <a href="https://auth0.com/docs/api-auth/tutorials/authorization-code-grant">la documentation ici</a>.</p>

            <h2>Paramètres de l'API</h2>

            <p>Par défaut, l'API retourne les données du jour.</p>

            <p>Cette date peut être changée en passant certains paramètres :</p>

            <ul>
                <li>
                    <em>date</em> : pour obtenir les données de la date <em>date</em>, à passer au format 'YYYY-MM-DD'
                    <pre>
https://api.singlespot.com/publisher_api/v1/devices?date=YYYY-MM-DD
                    </pre>
                </li>
                <li>
                    <em>start_date</em> et <em>end_date</em> : pour obtenir les données sur la période comprise entre <em>start_date</em> et <em>end_date</em>. Les dates sont à passer au format 'YYYY-MM-DD'
                    <pre>
https://api.singlespot.com/publisher_api/v1/devices?start_date=YYYY-MM-DD&end_date=YYYY-MM-DD
                    </pre>
                </li>
            </ul>
        </>
    );
};

export default DocFr;